(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initNavigation() {
    var toggle = document.querySelector('[data-okdo-menu-toggle]');
    var menu = document.querySelector('[data-okdo-menu]');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.classList.toggle('is-open', !open);
      document.body.classList.toggle('okdo-menu-open', !open);
    });

    menu.addEventListener('click', function (event) {
      if (!event.target.closest('a')) return;
      toggle.setAttribute('aria-expanded', 'false');
      menu.classList.remove('is-open');
      document.body.classList.remove('okdo-menu-open');
    });
  }

  function formatMoney(cents, currency) {
    if (typeof cents !== 'number') return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || 'MYR',
        maximumFractionDigits: cents % 100 === 0 ? 0 : 2
      }).format(cents / 100);
    } catch (error) {
      return (currency || 'MYR') + ' ' + (cents / 100).toFixed(2);
    }
  }

  function initStage(root) {
    var stage = root.querySelector('[data-okdo-stage]');
    var image = root.querySelector('[data-okdo-stage-image]');
    var model = stage ? stage.querySelector('model-viewer') : null;
    var readout = root.querySelector('[data-okdo-stage-readout] strong');
    var views = root.querySelectorAll('[data-okdo-view]');
    var hotspots = root.querySelectorAll('[data-okdo-hotspot]');
    if (!stage || !image) return;

    var drag = { active: false, pointerId: null, startX: 0, startY: 0, x: 0, y: 0, switched: false };

    function renderTilt(x, y) {
      if (prefersReducedMotion) return;
      var rect = stage.getBoundingClientRect();
      var nx = Math.max(-1, Math.min(1, x / Math.max(rect.width, 1)));
      var ny = Math.max(-1, Math.min(1, y / Math.max(rect.height, 1)));
      stage.style.setProperty('--okdo-ry', (nx * 7).toFixed(2) + 'deg');
      stage.style.setProperty('--okdo-rx', (ny * -5).toFixed(2) + 'deg');
      stage.style.setProperty('--okdo-shift-x', (nx * 0.45).toFixed(2) + 'rem');
      stage.style.setProperty('--okdo-shift-y', (ny * 0.3).toFixed(2) + 'rem');
    }

    function resetTilt() {
      renderTilt(0, 0);
    }

    stage.addEventListener('pointerdown', function (event) {
      if (event.target.closest('button') || event.target.closest('model-viewer')) return;
      drag.active = true;
      drag.pointerId = event.pointerId;
      drag.startX = event.clientX;
      drag.startY = event.clientY;
      drag.x = 0;
      drag.y = 0;
      drag.switched = false;
      stage.classList.add('is-dragging');
    });

    function handlePointerMove(event) {
      if (!drag.active || event.pointerId !== drag.pointerId) return;
      drag.x = event.clientX - drag.startX;
      drag.y = event.clientY - drag.startY;
      renderTilt(drag.x, drag.y);
      if (!drag.switched && Math.abs(drag.x) >= 42 && Math.abs(drag.x) > Math.abs(drag.y)) {
        changeView(drag.x < 0 ? 1 : -1);
        drag.switched = true;
      }
    }

    window.addEventListener('pointermove', handlePointerMove, { passive: false });

    function activateView(button) {
      if (!button) return;
      views.forEach(function (item) {
        item.classList.toggle('is-active', item === button);
        item.setAttribute('aria-pressed', String(item === button));
      });

      var viewIndex = Array.prototype.indexOf.call(views, button);
      stage.dataset.viewIndex = String(Math.max(viewIndex, 0));
      var isModel = button.dataset.kind === 'model' && model;
      if (model) model.hidden = !isModel;
      image.hidden = Boolean(isModel);

      if (!isModel && button.dataset.image) {
        image.style.opacity = '0';
        window.setTimeout(function () {
          image.src = button.dataset.image;
          image.alt = button.dataset.alt || image.alt;
          image.style.opacity = '1';
        }, prefersReducedMotion ? 0 : 100);
      }

      if (readout) readout.textContent = button.dataset.readout || '';
      hotspots.forEach(function (item) { item.classList.remove('is-active'); });
      resetTilt();
    }

    function changeView(delta) {
      if (views.length < 2) return;
      var active = root.querySelector('[data-okdo-view].is-active');
      var index = Array.prototype.indexOf.call(views, active);
      if (index < 0) index = 0;
      activateView(views[(index + delta + views.length) % views.length]);
    }

    function endDrag(event) {
      if (!drag.active || event.pointerId !== drag.pointerId) return;
      drag.active = false;
      stage.classList.remove('is-dragging');
      if (!drag.switched && Math.abs(drag.x) >= 42 && Math.abs(drag.x) > Math.abs(drag.y)) {
        changeView(drag.x < 0 ? 1 : -1);
      }
      resetTilt();
    }

    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);

    stage.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        changeView(event.key === 'ArrowRight' ? 1 : -1);
        return;
      }
      var map = { ArrowUp: [0, -50], ArrowDown: [0, 50] };
      if (!map[event.key]) return;
      event.preventDefault();
      renderTilt(map[event.key][0], map[event.key][1]);
    });

    stage.addEventListener('keyup', function (event) {
      if (event.key === 'ArrowUp' || event.key === 'ArrowDown') resetTilt();
    });

    views.forEach(function (button) {
      button.addEventListener('click', function () {
        activateView(button);
      });
    });

    hotspots.forEach(function (button) {
      button.addEventListener('click', function () {
        hotspots.forEach(function (item) { item.classList.toggle('is-active', item === button); });
        if (readout) readout.textContent = button.dataset.label || '';
      });
    });
  }

  function initProduct(root) {
    var jsonNode = root.querySelector('[data-okdo-product-json]') || document.querySelector('[data-okdo-product-json]');
    var form = root.querySelector('[data-okdo-product-form]');
    if (!form || !jsonNode) return;

    var variants = [];
    try { variants = JSON.parse(jsonNode.textContent); } catch (error) { variants = []; }

    var currency = root.dataset.moneyCurrency || 'MYR';
    var labels = {
      add: root.dataset.labelAdd || 'Add to Cart',
      sold: root.dataset.labelSold || 'Sold Out',
      unavailable: root.dataset.labelUnavailable || 'Unavailable',
      stock: root.dataset.labelStock || 'In stock for Malaysia & Thailand',
      noStock: root.dataset.labelNoStock || 'Currently unavailable'
    };
    var idInput = form.querySelector('[data-okdo-variant-id]');
    var price = root.querySelector('[data-okdo-price]');
    var stickyPrice = root.querySelector('[data-okdo-sticky-price]') || document.querySelector('[data-okdo-sticky-price]');
    var comparePrice = root.querySelector('[data-okdo-compare-price]');
    var stockLine = root.querySelector('[data-okdo-stock-line]');
    var addButton = form.querySelector('[data-okdo-add]');
    var addLabel = form.querySelector('[data-okdo-add-label]');
    var buyNow = form.querySelector('[data-okdo-buy-now]');
    var stickyAdd = root.querySelector('[data-okdo-sticky-add]') || document.querySelector('[data-okdo-sticky-add]');
    var status = form.querySelector('[data-okdo-form-status]');
    var optionGroups = form.querySelectorAll('[data-okdo-option-group]');

    function selectedOptions() {
      return Array.prototype.map.call(optionGroups, function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : '';
      });
    }

    function findVariant() {
      var options = selectedOptions();
      if (!options.length) return variants[0];
      return variants.find(function (variant) {
        return variant.options.every(function (value, index) { return value === options[index]; });
      });
    }

    function updateVariant() {
      var variant = findVariant();
      optionGroups.forEach(function (group) {
        var output = group.querySelector('[data-okdo-option-value]');
        var checked = group.querySelector('input:checked');
        if (output && checked) output.textContent = checked.value;
      });

      if (!variant) {
        [addButton, buyNow, stickyAdd].forEach(function (button) { if (button) button.disabled = true; });
        if (addLabel) addLabel.textContent = labels.unavailable;
        if (status) status.textContent = 'This combination is not available.';
        return;
      }

      if (idInput) idInput.value = variant.id;
      var formatted = formatMoney(variant.price, currency);
      if (price) price.textContent = formatted;
      if (stickyPrice) stickyPrice.textContent = formatted;
      if (comparePrice) {
        var showCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
        comparePrice.hidden = !showCompare;
        comparePrice.textContent = showCompare ? formatMoney(variant.compare_at_price, currency) : '';
      }

      [addButton, buyNow, stickyAdd].forEach(function (button) { if (button) button.disabled = !variant.available; });
      if (addLabel) addLabel.textContent = variant.available ? labels.add : labels.sold;
      if (stockLine) {
        stockLine.classList.toggle('is-unavailable', !variant.available);
        stockLine.lastChild.textContent = variant.available ? ' ' + labels.stock : ' ' + labels.noStock;
      }
      if (status) status.textContent = '';

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    optionGroups.forEach(function (group) { group.addEventListener('change', updateVariant); });

    function setBusy(busy) {
      [addButton, buyNow, stickyAdd].forEach(function (button) {
        if (button) button.disabled = busy || button.disabled;
      });
      form.setAttribute('aria-busy', String(busy));
    }

    function addToCart(goToCheckout) {
      if (!idInput || !idInput.value) return;
      setBusy(true);
      if (status) {
        status.classList.remove('is-error');
        status.textContent = goToCheckout ? 'Preparing secure checkout…' : 'Adding to cart…';
      }

      var rootPath = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      fetch(rootPath + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (response) {
          if (!response.ok) return response.json().then(function (data) { throw new Error(data.description || 'Unable to add this item.'); });
          return response.json();
        })
        .then(function () {
          if (window.okdoTrack) window.okdoTrack(goToCheckout ? 'okdo_begin_checkout' : 'okdo_add_to_cart', { variant_id: idInput.value });
          if (goToCheckout) {
            window.location.assign('/checkout');
            return;
          }
          if (status) status.innerHTML = 'Added to cart. <a href="' + rootPath + 'cart">View cart</a>';
          setBusy(false);
          updateVariant();
        })
        .catch(function (error) {
          if (status) {
            status.classList.add('is-error');
            status.textContent = error.message || 'Unable to add this item. Please try again.';
          }
          setBusy(false);
          updateVariant();
        });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      addToCart(false);
    });

    if (buyNow) buyNow.addEventListener('click', function () { addToCart(true); });
    if (stickyAdd) stickyAdd.addEventListener('click', function () { form.requestSubmit(addButton); });
  }

  function init() {
    initNavigation();
    document.querySelectorAll('[data-okdo-product-root]').forEach(function (root) {
      initStage(root);
      initProduct(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
